import { Dispatch } from 'react';
import { History } from 'history';
import { makeSIPValidation } from '../../../../../redux-store/actions/commercialTransactions';
import { isMobileDevice, OTP_ACTIONS } from '../../../../../utils/constants';
import {
    SipPaths,
    SIPSubmitRequestType,
    SipSummaryObjectType,
    SIPValidateRequestType,
} from '../types';
import { IsAllow } from '../../../../../redux-store/types/portfolio';
import { CommercialRootPath } from '../../routeConfig';
import { sendPhoneOTP } from '../../../../../redux-store/actions/nct';

// generate the common payload for both sip submit and sip validate function in the first function call
const genereteCommonPayload =
    (row: SipSummaryObjectType, trxnType: 'CSIP' | 'PSIP') =>
    (userTrxnNo: string): SIPValidateRequestType => {
        return {
            data: [
                {
                    amc: row.amc,
                    schemeOptions: [
                        {
                            folio: row.folio,
                            schemeCode: row.schemeCode,
                            userTrxnNo,
                            trxnType,
                            itemNo: '',
                            isin: row.isin,
                            pauseInstallments: '',
                        },
                    ],
                },
            ],
        };
    };

const isTrxnValid = (
    trxnType: 'CSIP' | 'PSIP',
    isPauseAllowed: IsAllow,
    isCancelAllowed: IsAllow,
) => {
    const pauseValid = trxnType === 'PSIP' && isPauseAllowed === IsAllow.YES;
    const cancelValid = trxnType === 'CSIP' && isCancelAllowed === IsAllow.YES;
    return pauseValid || cancelValid;
};

export const sipValidate =
    (row: SipSummaryObjectType, dispatch: Dispatch<any>, history: History<unknown>) =>
    async (trxnType: 'CSIP' | 'PSIP') => {
        const sipCommonPayload = genereteCommonPayload(row, trxnType);
        const sipPausePayload = sipCommonPayload(row.userTrxnNo);
        const {
            body: { success, reqId },
        } = await makeSIPValidation(sipPausePayload)(dispatch);
        if (isTrxnValid(trxnType, success[0].isPauseAllowed, success[0].isCancelAllowed)) {
            const sipSubmitPayload = sipCommonPayload(success[0].userTrxnNo);
            try {
                const otpPayload = {
                    reqId,
                    action: OTP_ACTIONS.sipPause,
                };
                const otpRes = await sendPhoneOTP(otpPayload)(dispatch);
                history.push(`${CommercialRootPath}${SipPaths.SipOTP}`, {
                    apiPayload: sipSubmitPayload,
                    reqId: otpRes.body.reqId,
                    pauseFlag: trxnType === 'PSIP',
                    otpRef: otpRes.body.otpRef
                });
            } catch (err: any) {
                throw err;
            }
        } else {
            const errorText = trxnType === 'PSIP' ? 'Pause' : 'Cancel';
            throw new Error(`SIP ${errorText} is not allowed for this scheme`);
        }
    };
